import React, { useState } from "react";
import {Link, useLocation} from "react-router-dom";
import {myroutes} from "../../routes/webroute";
import { useDispatch, useSelector } from "react-redux";
import { resetAuthData } from "../app/providers/authSlice";
import { logoutUser } from "../auth/logout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from 'primereact/button';


export default function SideBar() {

    const location = useLocation();
    const url = location.pathname;
    const dispatch = useDispatch()
    const auth = useSelector(state => state.auth)
    const [isActive, setIsActive] = useState(false);
    
    const handleClick = () => {
        setIsActive(!isActive);
      };
    


     // se déconnecter
	const handleLogout = () => {  
		logoutUser(auth.token);
		dispatch(resetAuthData());
	}

    return (
        <React.Fragment>
            {/*Menu*/}
            <aside id="layout-menu" className=" layout-menu menu-vertical menu bg-menu-theme-background" >
                <div className="app-brand demo">
                    <Link to={myroutes.login} className="app-brand-link">
              <span className="app-brand-logo demo">
                {/*logo du site */}
              </span>
                        <span className="app-brand-text demo menu-text fw-bolder " 
                        style={{color:"#FDA639", fontFamily:"Arial Narrow", textTransform:"uppercase", }}> 
                        G-Schoolarys </span>
                    </Link>
                   {/**   <a href="javascript:void(0);" class="layout-menu-toggle menu-link text-large ms-auto">
                <i class="bx bx-chevron-left bx-sm align-middle"></i>
                </a>
            */}
                   <Link
                        className="layout-menu-toggle menu-link text-large ms-auto d-block d-xl-none">
                        <i className="bx bx-chevron-left bx-sm align-middle"></i>
                   </Link>
                </div>

          
                <div className="menu-inner-shadow"></div>

                <ul className="menu-inner py-1">
                    {/* Dashboard */}
                    <li className={url === myroutes.dashboard ? 'menu-item' : 'menu-item'}>
                        <Link to={myroutes.dashboard} className={url === myroutes.dashboard ? 'menu-link active' : 'menu-link'}>
                            <i className="menu-icon tf-icons bx bx-home-circle"></i>
                            <div data-i18n="">Tableau de bord</div>
                        </Link>
                    </li>
                
                    <li className="menu-header small text-uppercase">
                        <span className="menu-header-text" style={{color:"grey"}}>--- Nos modules</span>
                    </li> 
                    <li className={url === myroutes.inscription_create ? 'menu-item' : 'menu-item'} state={{parametre : 0 }}>
                    <Link to={myroutes.inscription_create} state={{ parametre: 0 }} className={url === myroutes.inscription_create ? 'menu-link menu-item1 active' : 'menu-link menu-item1'}>
                    <i className="menu-icon tf-icons bx bx-user"></i>
                        <div data-i18n="Parameter">Inscription</div>
                    </Link>
                </li>

                    <li className={url === myroutes.inscriptions ? 'menu-item' : 'menu-item'} >
                    <Link to={myroutes.inscriptions} className={url === myroutes.inscriptions ? 'menu-link menu-item1 active' : 'menu-link menu-item1'}>
                    <i className='menu-icon tf-icons bx bxs-user-detail'></i>
                        <div data-i18n="Parameter">Liste  des inscrits</div>
                    </Link>
                </li>
                    

                    {/* Emplois du temps 
                    <li className="menu-item">

                        <Link className="menu-link menu-toggle submenu-toggle" data-bs-toggle="collapse"
                              data-bs-target="#submenu-2" aria-expanded="false" aria-controls="submenu-2">
                            <i className='menu-icon tf-icons bx bxs-timer'></i>
                            <div data-i18n="Layouts">Emplois du temps</div>
                        </Link>
                        <div id="submenu-2" className="collapse submenu submenu-2" data-bs-parent="#menu-accordion">
                            <ul className="submenu-list list-unstyledx">
                                <li className="menu-item">
                                    <Link to={myroutes.emploidutemps_enseignants} className="menu-link">
                                        <div data-i18n="Without menu">Emploi du temps des enseignants</div>
                                    </Link>
                                </li>
                                <li className="menu-item">
                                    <Link className="menu-link">
                                        <div data-i18n="Without navbar">Emploi du temps des classes</div>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </li>*/}
                     {/*gParamètres */}
                     <li className="menu-header small text-uppercase">
                        <span className="menu-header-text" style={{color:"grey"}}>--- Paramètres</span>
                    </li>

                    <li className={url === myroutes.parametres ? 'menu-item' : 'menu-item'}>
                        <Link to={myroutes.parametres} className={url === myroutes.parametres ? 'menu-link menu-item1 active' : 'menu-link menu-item1'}>
                            <i className="menu-icon tf-icons bx bx-cog"></i>
                            <div data-i18n="Parameter">Paramètres</div>
                        </Link>
                    </li>

                    {/*logout */}
                    <li className="menu-header small text-uppercase">
                        <span className="menu-header-text" style={{color:"grey"}}>--- Gestion Site</span>
                    </li>
                   
                    <li className="menu-item">
                        <a  href="#" className="menu-link">
                        <FontAwesomeIcon icon="fa-solid fa-cloud menu-icon tf-icons" /> &nbsp;&nbsp;&nbsp;
                            <div data-i18n="Parameter">Active storage</div>
                        </a>
                    </li>
                    <li className="menu-item">
                        <a  href="#" className="menu-link">
                        <FontAwesomeIcon icon="fa-solid fa-trash menu-icon tf-icons" /> &nbsp;&nbsp;&nbsp;
                            <div data-i18n="Parameter">Vider le cache</div>
                        </a>
                    </li>
                    <li className="menu-header small text-uppercase">
                        <span className="menu-header-text" style={{color:"grey"}}>--- Déconnexion</span>
                    </li>
                    <li className="menu-item">
                        <a onClick={() => handleLogout()} href="#" className="menu-link">
                        <FontAwesomeIcon icon="fa-solid fa-right-from-bracket menu-icon tf-icons" /> &nbsp;&nbsp;&nbsp;
                            <div data-i18n="Parameter">Se déconnecter</div>
                        </a>
                    </li>
                </ul>
                <div className="col-lg-12">
                    <div className="row">
                        <div className="col-lg-3">

                        </div>
                        <div className="col-lg-5">
                        <img src="/images/logo_gs_blanc.png" alt="" style={{width:"100px", textAlign:"center"}}/>
                        </div>
                        <div className="col-lg-5">
                        </div>
                    </div>
                </div>
                <div>
                </div>
            </aside>
            {/*end Menu*/}
        </React.Fragment>
    )
}